var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tableItem.keys.length > 1)?_c('span',{ref:"iiotLabelMergefixCaseModal",staticClass:"flat-button ma-0 cursor-pointer",attrs:{"id":"iiotFixCaseButton"},on:{"click":[function($event){return _vm.fixCaseModal()},function($event){$event.preventDefault();$event.stopPropagation();}]}},[_vm._v(" "+_vm._s(_vm.$t('labels.merge.fixCase'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }